import { config } from '../config/runtimeConfig.js';

/**
 * Фото демо-стока лежат в самом b2b-demo (`public/assets/cars/demo/`, #1416),
 * а в источнике записаны АБСОЛЮТНЫМИ ссылками на прод-хост — так их берут и
 * витрина внутри b2b-ui, и виджет на чужих сайтах: относительный путь там
 * разрешился бы против чужого домена.
 *
 * Тест и прод читают одну и ту же вкладку таблицы, поэтому развести ссылки
 * по окружениям в данных нельзя. Тестовая витрина вместо этого переписывает
 * хост у себя: `VITE_DEMO_ASSETS_ORIGIN` в её helm-values. Без переменной
 * (прод, виджет у дилера) ссылки идут как есть.
 *
 * Переписывается только точный префикс `https://demo.shiftgears.ai/…` —
 * так их пишет источник; фото дилеров и бакета не трогаем.
 */
export const DEMO_ASSETS_PREFIX = 'https://demo.shiftgears.ai/assets/cars/demo/';

// `trim()` до проверки: пробел или перевод строки в helm-значении ломал бы все
// фото сразу, а значение из одних пробелов давало бы относительный путь.
const normalizeOrigin = (origin) => (typeof origin === 'string' ? origin.trim().replace(/\/+$/, '') : '');

export const rebaseDemoAsset = (url, origin = config.DEMO_ASSETS_ORIGIN) => {
  const base = normalizeOrigin(origin);
  if (!base || typeof url !== 'string' || !url.startsWith(DEMO_ASSETS_PREFIX)) {
    return url;
  }
  return `${base}/assets/cars/demo/${url.slice(DEMO_ASSETS_PREFIX.length)}`;
};

export const rebaseDemoAssets = (images, origin = config.DEMO_ASSETS_ORIGIN) =>
  normalizeOrigin(origin) ? images.map((url) => rebaseDemoAsset(url, origin)) : images;
